module.exports = __webpack_public_path__ + "img/dai8.408b5aa6.png";